export default __webpack_public_path__ + "static/media/WalkleLogo.86b842d2.svg";